import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'slt-common',
  styles: ``,
  template: ` <p>common works!</p> `,
})
export class Common {}
